var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-field",style:(_vm.rootStyle)},[_c('label',{staticClass:"c-field__label",style:(_vm.labelStyle)},[_vm._v("\n        "+_vm._s(_vm.label)+"\n        "),(_vm.optional)?_c('span',{staticClass:"c-field__optional",style:(_vm.optionalStyle)},[_vm._v("optional")]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }